import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend'; // ✅ Ajout du backend

i18n
  .use(HttpBackend) // ✅ pour charger les traductions via HTTP
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'it',
    supportedLngs: ['it', 'fr', 'en', 'de', 'pt', 'es', 'ru'],
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: 'https://villa-santeodoro.com/locales/{{lng}}/translation.json' // ✅ point vers tes fichiers distants
    }
  });

export default i18n;
